module.exports = __webpack_public_path__ + "img/image-from-rawpixel-id-2312450-jpeg.a0130416.jpg";